export const BannerTypes = {
  BOOK: 'BOOK',
  BOOKS: 'BOOKS',
  ADVERTISEMENTS: 'ADVERTISEMENTS',
}
